<head>
   
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous">

  </head>


  <div class="container">
    <div class="row">
      <div class="col">
      </div>
      <div class="col-8">
          <br><BR>
        <h1>VISITOR</h1>
<table class="table table-hover">
    <thead>
      <tr>
        <th scope="col">IP</th>
        <th scope="col">COUNTRY</th>
        <th scope="col">REGION</th>
        <th scope="col">ZIP</th>
        <th scope="col">DEVICE TYPE</th>
        <th scope="col">OS</th>
        <th scope="col">BROWSER</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of itemArray ">
        <th>{{item.ipAddress}}</th>
        <td>{{item.country_name}}</td>
        <td>{{item.region_name}}</td>
        <td>{{item.zipcode}}</td>
        <td>{{item.deviceType}}</td>
        <td>{{item.deviceOS}}</td>
        <td>{{item.browser}}</td>
      </tr>
    </tbody>
  </table>
      </div>
      <div class="col">
      </div>
    </div>
    </div>

    <script src="https://code.jquery.com/jquery-3.2.1.slim.min.js" integrity="sha384-KJ3o2DKtIkvYIK3UENzmM7KCkRr/rE9/Qpg6aAZGJwFDMVNA/GpGFF93hXpG5KkN" crossorigin="anonymous"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js" integrity="sha384-ApNbgh9B+Y1QKtv3Rn7W3mgPxhU9K/ScQsAP7hUibX39j7fakFPskvXusvfa0b4Q" crossorigin="anonymous"></script>
<script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/js/bootstrap.min.js" integrity="sha384-JZR6Spejh4U02d8jOt6vLEHfe/JQGiRRSQQxSfFWpi1MquVdAyjUar5+76PVCmYl" crossorigin="anonymous"></script>